import React, { useState, useEffect } from 'react';
import { getPublicFolderPath } from '../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Snackbar from '@material-ui/core/Snackbar';
import NotificationContent from './NotificationContent';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  snackbar: {
    '& .MuiSnackbarContent-message': { width: '100%' },
    '& .MuiSnackbarContent-root': {
      width: 550,
      backgroundColor: theme.palette.brand.dark,
      color: theme.palette.brand.greyLight,
    },
  },
  learnMoreSnackbar: { bottom: 85 },
  learnMoreButton: {
    color: theme.palette.brand.blueGrey,
    fontWeight: 400,
    padding: 0,
  },
  learnMoreIcon: { marginLeft: theme.spacing(1) },
  actionButtons: { fontWeight: 400, padding: 0, color: 'white' },
  buttonRight: { marginRight: theme.spacing(1) },
}));

export default function Notification({
  handleClose,
  open,
  notification,
  trackEvent,
}) {
  const classes = useStyles();
  const { id, message, learnMoreMessage, icon, action } = notification;
  const [userSawMessage, setUserSawMessage] = useState(false);
  const [showLearnMoreMessage, setShowLearnMoreMessage] = useState(false);

  function trackUser(tookAction: boolean) {
    trackEvent({
      event: 'user_interacted_with_notification',
      type: notification.type,
      message: notification.message,
      userAction: tookAction ? action.name : 'Dismissed',
      lineId: notification.lineId,
    });
  }

  function handleLearnMoreClick() {
    setShowLearnMoreMessage(!showLearnMoreMessage);
    if (!userSawMessage) {
      setUserSawMessage(true);
    }
  }

  function getSnackbarActions() {
    let learnMoreIcon = getPublicFolderPath(window.location.pathname);
    let learnMoreText = '';
    if (showLearnMoreMessage) {
      learnMoreText = 'Hide details';
      learnMoreIcon += 'general/arrowDown.svg';
    } else {
      learnMoreText = 'Learn more';
      learnMoreIcon += 'general/arrowUp.svg';
    }

    return (
      <>
        <Button
          onClick={handleLearnMoreClick}
          className={classes.learnMoreButton + ' ' + classes.buttonRight}
        >
          {learnMoreText}{' '}
          <img src={learnMoreIcon} alt="" className={classes.learnMoreIcon} />
        </Button>
        {userSawMessage && (
          <>
            {action && (
              <Button
                onClick={async () => {
                  await action.onClick();
                  trackUser(true);
                  handleClose(id);
                }}
                className={classes.actionButtons + ' ' + classes.buttonRight}
              >
                {action.name}
              </Button>
            )}

            <Button
              onClick={() => {
                trackUser(false);
                handleClose(id);
              }}
              className={classes.actionButtons}
            >
              Dismiss
            </Button>
          </>
        )}
      </>
    );
  }

  function resetState() {
    setTimeout(() => {
      setUserSawMessage(false);
      setShowLearnMoreMessage(false);
    }, 500);
  }

  useEffect(() => {
    if (!open) {
      resetState();
    }
  }, [open, setUserSawMessage, setShowLearnMoreMessage]);

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
        message={
          <NotificationContent
            message={message}
            icon={getPublicFolderPath(window.location.pathname) + icon}
            actions={getSnackbarActions()}
          />
        }
        className={classes.snackbar}
      />
      {showLearnMoreMessage && open && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={open}
          message={
            <NotificationContent
              message={learnMoreMessage}
              learnMoreMessage={true}
            />
          }
          className={classes.snackbar + ' ' + classes.learnMoreSnackbar}
        />
      )}
    </>
  );
}
